import { useTriggerDesigns } from "./TriggerDesignsContext.ts";

export const useHaveTriggers = (nodeId: number) => {
  const { getHaveTriggers } = useTriggerDesigns();
  return getHaveTriggers(nodeId);
};
